import { createGlobalStyle } from 'styled-components'
import { PancakeTheme } from '@pancakeswap/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Digitalt';
    src: local('Digitalt'), url('/fonts/Digitalt/Digitalt.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Familjen-Grotesk';
    src: local('Familjen-Grotesk'), url('/fonts/Familjen-Grotesk/FamiljenGrotesk-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Familjen-Grotesk';
    font-weight: bold;
    src: local('Familjen-Grotesk'), url('/fonts/Familjen-Grotesk/FamiljenGrotesk-Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Inter';
    src: local('Inter'), url('/fonts/Inter/Inter-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: bold;
    src: local('Inter'), url('/fonts/Inter/Inter-Bold.ttf') format('truetype');
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background: ${({ theme }) => theme.colors.background};
    font-family: Familjen-Grotesk;

    img {
      height: auto;
    }

    top: 0 !important;
    width: 100% !important;
  }

  .container {
    position: relative;
    z-index: 10;
    width: 100%;
    height: 100%;
    max-width: 1300px;
    padding: 0 14px;
    margin: 0 auto;
  }

  .underline {
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    background: linear-gradient(99.46deg, #fa00ff -10.9%, #00e0ff 97.13%, #2ad4f9 97.14%);
    height: 2px;
    width: 100%;
  }

  .rotate {
    transform: rotate(180deg);
  }

  .error {
    font-size: 12px;
    color: #FF4842;
  }

  .ant-layout{
    overflow-x: hidden;
  }

  // ant select dropdown
  .ant-form-item {
    margin: 0;
  }
  .ant-select-dropdown {
    padding: 0; 
    background: #FFFFFF; 
    border-radius: 10px; 
    overflow: hidden;
  }
  .ant-select-item {
    color: #000000; 
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    color: #000000; 
    background: #83ccf045; 
  }
  .ant-select-arrow {
    img {
      transform: rotate(180deg);
    }
  }
  .ant-select-open .ant-select-arrow {
    img {
      transform: rotate(0deg);
    }
  }

  // CSS ANT SELECT

  .ant-select-dropdown.select-parent {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    min-height: 40px;

    .ant-select-selector {
      padding-top: 4px;
      border: none;
      border-color: transparent !important;
      box-shadow: none !important;

      .ant-select-selection-search-input {
        margin-top: 4px;
        padding-left: 26px;
      }

      .ant-select-selection-item{
        padding-left: 24px;
      }
    }
  }
  
  .ant-select-dropdown.select-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;

    .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
      background: #FFFFFF;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
      border-radius: 3px;
    }

    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background: rgba(0, 109, 254, 0.2);
      color: #000;
      font-weight: 400;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
      
        width: 7px;
        height: 7px;
        background: #006DFE;
        border-radius: 50%;
      }
    }
  }

  // CSS ANT SELECT 



  #google_translate_element, .skiptranslate iframe{
    display: none;
  }

  .ReactModal__Overlay{
    z-index: 999;
  }

  .modal{
    width: 80%;
    background: #fff;
    height: 80%;
    top: 50%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 25px;
  }

  .member-modal{
    width: 90%;
    height: 90%;
    max-width: 700px;

    ${({ theme }) => theme.mediaQueries.sm} {
      width: 80%;
    }

    ${({ theme }) => theme.mediaQueries.lg} {
      width: 50%;
      height: fit-content;
    }
  }

  .close-btn{
    img{
      width: 15px;
    }
    position: absolute;
    right: 15px;
    top: 10px;
    z-index: 999;
    cursor: pointer;
  }

  .pointer{
    cursor: pointer;
  }
 
  .modal-show-iframe{
    .ant-modal-footer, .ant-modal-close{
      display: none;
    }
    .modal-video{
      max-width: 1068px;
      width: 100%;
      max-height: 579px;
      height: 100%;
      z-index: 1000;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: fixed;
      &>div:first-child{
        width: 100%;
        height: 100%;
      }
    }
    .content-progress-modal{
      width: 100%;
      padding: 23px;
      text-align: center;
      background: #fff;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
      border-radius: 15px;
    }
  }
  
  .slick-dots{
    bottom: -2.5rem;

    .slick-active{
      button:before {
        color: #006DFE !important;
      }
    }

    li button{
      &:before {
        font-size: 11px;
      }

      &:hover:before, &:focus:before {
        color: #006DFE !important;
      }
    }
  }

  .sort-attr {
    position: relative;
    cursor: pointer;

    .sort-item {
      position: absolute;
      top: 50%;
      transform: translateY(-18%);
      right: 2px;
      width: 0;
      height: 0;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      display: none;
      border-top-color: #6d6d6d;
      display: block;
    }

    .asc {
      border-bottom: 5px solid #6d6d6d;
    }

    .desc {
      border-top: 5px solid #6d6d6d;
    }

    &.active {
      .asc {
        border-bottom: 5px solid #000;
      }
  
      .desc {
        border-top: 5px solid #000;
      }
    }
  }

  .see-more{
    font-style: normal;
    font-weight: 400 !important;
    font-size: 16px;
    line-height: 20px;
    text-align: right;
    color: #006DFE !important;
  }

  .responsive-flex{
    display: flex;
    flex-direction: column;
    gap: 2rem;

    ${({ theme }) => theme.mediaQueries.lg} {
      flex-direction: row;
    }
  }

  .responsive-flex-md{
    display: flex;
    flex-direction: column;
    gap: 2rem;

    ${({ theme }) => theme.mediaQueries.md} {
      flex-direction: row;
    }
  }

  .responsive-flex-xxl{
    display: flex;
    flex-direction: column;
    gap: 2rem;

    ${({ theme }) => theme.mediaQueries.xxl} {
      flex-direction: row;
    }
  }

  .ant-tooltip {
    max-width: 350px;
  }

  .tooltip-content-dark{
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 120%;
    text-align: center;
    color: #6D6D6D;
  }

  .ant-tooltip-inner{
    border-radius: 5px;
  }

  .box-arrow {
    position: relative;
    cursor: pointer;

    .arrow-default {
      opacity: 1;
      transition: 0.25s;
    }

    .arrow-hover {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.25s;
    }

    &:hover {
      .arrow-default {
        opacity: 0;
      }

      .arrow-hover {
        opacity: 1;
      }
    }

    &.box-arrow-custom-left, &.box-arrow-custom-right{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }

    &.box-arrow-custom-right{
      left: -23px;;
      right: auto;
    }

    &.box-arrow-custom-left{
      right: -23px;
      left: auto;
    }
  }

  .hidden-all {
    position: absolute;
    top: 0%;
    transform: translateY(-100%);
    opacity: 0;
    pointer-events: none;
  }

  .ant-dropdown{
    padding-top: 8px;
  }

  .tooltip-hover-nft{
    max-width: initial;

    .ant-tooltip-inner{
      background-color: unset;
      box-shadow: unset;
    }

    .ant-tooltip-arrow{
      display: none;
    }
  }

  .tooltip-hover-collection{
    width: 100%;
    max-width: 1040px;
    min-height: 200px;
    padding-bottom: 0;

    .ant-tooltip-inner{
      background-color: unset;
      box-shadow: unset;
    }

    .ant-tooltip-arrow{
      display: none;
    }
  }

  .filter-blur{
    ${({ theme }) => theme.mediaQueries.lg} {
      filter: blur(10.5px);
      transition: 0.3s ease-in-out;
    }
  }

  .ant-modal-mask, .ant-modal-wrap{
    z-index: 999;
    max-width: 100vw;
  }

  .ant-modal-mask{
    ${({ theme }) => theme.mediaQueries.lg} {
      background-color: rgba(255, 255, 255, 0.48);
    }
  }

  .ant-modal-content{
    background-color: transparent;
    box-shadow: none;
  }

  .ant-modal-wrap {
    &.custom-modal-mobile {
      .ant-modal {
        @media (max-width: 767px) {
          position: fixed;
          bottom: 0;
          left:0;
          top: auto !important;

          width: 100% !important;
          max-width: 100%;
          height: fit-content;
          margin: 0;
          padding-bottom: 0;
        }
      }
      
    }

  }

  .ant-select-item {
    &.ant-select-item-group {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 15px;
      color: #000000;
      min-height: 27px;
      border-bottom: 1px solid rgba(109, 109, 109, 0.5);
    }
  }

  .ant-select-item-option-content {
    display: flex;
    align-items: center;

    img {
      margin-right: 3px;
    }
          
    p{
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #6D6D6D;

      img {
        width: 23px;
        height: 23px;
        margin-right: 8px;
      }
    }
  }

  .ant-select-item-option-grouped{
    padding-left: 16px;
  }

  .ant-select-item{
    padding-left: 16px;
  }

  .select-item-add {
    .ant-select-item-option-content {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      color: #006dfe;
    }
  }

  *::-webkit-scrollbar {
    @media (max-width: 767px) {
      display: none;
    }
  }
`

export default GlobalStyle
